// React core
import { useEffect } from "react";

// Third-party libraries

// App imports
import { SessionMode } from "../libs/constants/index.js";
import useAppStore from "../store/AppStore.js";
import useLiveAvatarStore from "../store/LiveAvatarStore.js";
import { useBoundStore } from "../store/UseBoundStore1.js";

// Components
import LoadLiveAvatar from "../components/Model/liveavatar.js";
import ConversationV2 from "../pages/Conversation-v2.js";
import UserPermissionsScreenNew from "../pages/UserPermissionsScreenNew.js";
// Component-level state
let setupDone = false;
let isSocketInitializedLocalRef = false;
export default function ConversationMaster() {
  // App store state
  const {
    permissions,
    socket,
    setSocket,
    accessToken,
    conversations,
    addMessage,
    canInitializeMediaStream,
    setCanInitializeMediaStream,
    setEndInterviewAfterSynthesis,
    isSetupDone,
    setIsSetupDone,
    isSocketInitialized,
    setIsSocketInitialized,
    shouldStartTheInterview,
  } = useAppStore();

  // Bound store state
  const { mId, mode, username, meetingId, setMeetingId } = useBoundStore();

  // LiveAvatar store state
  const { avatarMediaStream, opener, isAvatarStreamAvailable, avatarSession } =
    useLiveAvatarStore();

  useEffect(() => {
    if (mId && !meetingId) setMeetingId(mId);
    let avatarMediaStreamCheck =
      isAvatarStreamAvailable ||
      avatarMediaStream ||
      (mode && mode !== SessionMode.WEB_VIDEO);
    if (avatarMediaStreamCheck && !setupDone) {
      setupDone = true;
      setIsSetupDone(true);
      // setTimeout(() => {
      //   setIsSetupDone(true);
      // }, 500);
    }
  }, [avatarMediaStream, socket, opener, isAvatarStreamAvailable]);

  return (
    <div>
      {permissions.allPermissionsGranted && isSetupDone ? (
        <ConversationV2 />
      ) : (
        <UserPermissionsScreenNew />
      )}
      {mode === SessionMode.WEB_VIDEO && shouldStartTheInterview && (
        <LoadLiveAvatar />
      )}
    </div>
  );
}
